import type { useCurrentUser } from "@/contexts/current-user";

type CurrentUserData = ReturnType<typeof useCurrentUser>["data"];
type CurrentUserError = ReturnType<typeof useCurrentUser>["error"];

export function getProfileImageSrc(profileData: CurrentUserData): string {
  return profileData?.details.imageUrl || "/profile image placeholder.png";
}

export function getHasProfileError(profileError: CurrentUserError): boolean {
  return !!profileError;
}
